export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const VITE_AZURE_CLIENTID = process.env.REACT_APP_VITE_AZURE_CLIENTID;
export const VITE_AZURE_AUTHORITY = process.env.REACT_APP_VITE_AZURE_AUTHORITY;
/** Default country for service HeaderParam("countryCode"); override via REACT_APP_COUNTRY_CODE if needed. */
export const COUNTRY_CODE = process.env.REACT_APP_COUNTRY_CODE || 'IN';
